// Concept detail alias → canonical /codex/$slug.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/concepts/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/codex/$slug", params: { slug: params.slug }, statusCode: 301 });
  },
});
